import { VideoItemAdapter } from 'components/list';
import { videosList } from 'config/routes';
import { DI } from 'modules';
import React, { useMemo, useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

const INITIAL_COUNT = 4;

function ViewVideoSiblings(props) {
  const [loadMoreCount, setLoadMoreCount] = useState(INITIAL_COUNT);
  const { strings, locale, isMobile } = props.common;
  const allVideosPath = videosList.getPath(locale);

  const dataToRender = useMemo(
    () => (props.data || []).slice(0, loadMoreCount),
    [loadMoreCount, props.data]
  );

  function loadMoreHandle(event) {
    event.preventDefault();
    setLoadMoreCount(prev => prev + 10);
  }

  return (
    <div className="live-block" id="vod-siblings" data-view-type={props.isRelated ? 'related' : 'trending'}>
      <div className="dashboard-slider__title">
        <div className="page-title page-title--dashboard j-page-title">
          <span className="page-title__left j-page-title-left">
            <span className="live-info__title">
              {strings[`page.video.${props.isRelated ? 'related' : 'trending'}.title`]}
            </span>
          </span>
          <span
            className="page-title__right _init">
            <Link
              className="btn-bord btn-bord--arrow dashboard-slider__side-button"
              to={allVideosPath}
            >
              <span className="btn-bord__text">
                {strings['page.video.related.link']}
              </span>
            </Link>
          </span>
        </div>
        <div className="page-text">
          {strings[`page.video.${props.isRelated ? 'related' : 'trending'}.text`]}
        </div>
      </div>
      <div className="dashboard-slider-outer">
        <div className="dashboard-slider">
          <div className="dashboard-slider-list trending-list">
            {dataToRender.map((video, index) => (
              <VideoItemAdapter
                video={video}
                view="dbs"
                key={`${index}-${video.id}`}
                modificator="trending-item"
              />
            ))}
          </div>
          {loadMoreCount < (props.data || []).length && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              href="#"
              className="btn-bord btn-bord--more"
              onClick={loadMoreHandle}
            >
              {strings['page.search.show_more']}
            </a>
          )}

          {isMobile && (
            <Link
              className="btn-bord dashboard-slider__bottom-button"
              to={allVideosPath}
            >
              {strings['page.video.related.link']}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default DI(['common'])(withRouter(ViewVideoSiblings));
